export const PATH = 'PATH';
export const UIRED = 'UIRED';
export const CATEGORY = 'CATEGORY';
export const UNSUR = 'UNSUR';
export const UNSURALL = 'UNSURALL';
export const DICTIONARY = 'DICTIONARY';
export const SELECTEDCATEGORY = 'SELECTEDCATEGORY';
export const UNSURRESULTDIC = "UNSURRESULTDIC";
export const UNSURRESULTALL = "UNSURRESULTALL";
export const SELECTEDUNSUR = "SELECTEDUNSUR";
export const USERID = "USERID";
export const PROPERTY = "PROPERTY";
export const SEARCHTEXT = "SEARCHTEXT";

export function pushSearchText(values){
   return{
     type: SEARCHTEXT,
     payload:values
   };
}

export function pushProperty(values){
   return{
     type: PROPERTY,
     payload:values
   };
}

export function pushSelectedUnsur(values){
   return{
     type: SELECTEDUNSUR,
     payload:values
   };
}

export function pushUserId(values){
   return{
     type: USERID,
     payload:values
   };
}

export function pushSelectedCategory(values){
   return{
     type: SELECTEDCATEGORY,
     payload:values
   };
}

export function pushCategory(values){
   return{
     type: CATEGORY,
     payload:values
   };
}

export function pushDictionary(values){
   return{
     type: DICTIONARY,
     payload:values
   };
}

export function pushPath(values){
   return{
     type: PATH,
     payload:values
   };
}

export function pushUIRED(values){
   return{
     type: UIRED,
     payload:values
   };
}

export function pushUnsurResultAll(values){
   return{
     type: UNSURRESULTALL,
     payload:values
   };
}

export function pushUnsurResultDic(values){
   return{
     type: UNSURRESULTDIC,
     payload:values
   };
}

export function pushUnsur(values){
   return{
     type: UNSUR,
     payload:values
   };
}

export function pushUnsurAll(values){
   return{
     type: UNSURALL,
     payload:values
   };
}
